import { useQuery } from '@tanstack/vue-query'
import Organisation from '@/api/Dara/Organisation'
import { organisationKeys } from '@/composable/queries/keys'


export const useOrganisationLicenceTypesQuery = (
  organisationId: Ref<number>,
  enabled: Ref<boolean> = ref(true),
) =>
  useQuery({
    queryKey: organisationKeys.licenceTypes(organisationId),
    queryFn: () => Organisation.getLicenceTypes(organisationId.value),
    enabled,
  })
